import React from 'react'
import classNames from 'classnames'

import IProps from './interface'

const Tag = (props: IProps) => {
  const { text, classes, href, target } = props

  return  (
    href ? (
      <a
        href={href}
        target={target}
        className={classNames(
          {
            ['bubble-tag']: true,
            ['bubble-tag--link']: true,
          },
          classes || ''
        )}>
        {text}
      </a>
    ) : (
      <span
        className={classNames(
          {
            ['bubble-tag']: true,
          },
          classes || ''
        )}>
        {text}
      </span>
    )
  )
}

export default Tag
